module.exports = function() {
  return new Worker(__webpack_public_path__ + "f4bce6a70645d2fa8334.worker.js");
};